<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("pricing.menu.layout") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormVariants
                    :title="$t('pricing.layout.view_type')"
                    :variants="layouts"
                    v-model="pricing.layout"
                />

                <FormToggleSm
                    :title="$t('pricing.layout.show_layouts_toggle')"
                    v-model="pricing.showLayouts"
                />

                <FormToggleSm
                    :title="$t('pricing.layout.show_footer')"
                    v-model="pricing.showFooter"
                />

                <FormInput
                    id="pricingLinkName"
                    :title="$t('pricing.layout.bottom_page_link_name')"
                    v-model="pricing.linkName"
                />
                <div class="space-y-2">
                    <FormInput
                        v-if="pricing.ecLinkHref"
                        :title="$t('pricing.layout.bottom_page_link_url')"
                        disabled
                        v-model="pricing.ecLinkHref"
                        :help="$t('pricing.ec_info')"
                    />
                    <FormInput
                        :title="pricing.ecLinkHref ? '' : $t('pricing.layout.bottom_page_link_url')"
                        v-model="pricing.linkHref"
                    />
                </div>
                <FormInput
                    id="pricingBtnLabel"
                    :title="$t('pricing.layout.cta_label')"
                    v-model="pricing.btnLabel"
                />

                <FormInput
                    id="pricingFeatLabel"
                    :title="$t('pricing.layout.features_list_header')"
                    v-model="pricing.featLabel"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { FormVariants, FormToggleSm, FormInput } from "@easy/ui/forms";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";
import { usePricingCreatorStore } from "@/apps/pricing/project/onboarding/pricing-creator.store";
import { storeToRefs } from "pinia";

export default {
    components: {
        PageSidebar,
        FormVariants,
        FormToggleSm,
        FormInput,
        cSaveButton,
    },
    setup() {
        useFocusOnQueryField();
        const pricingCreatorStore = usePricingCreatorStore();
        const { layouts } = storeToRefs(pricingCreatorStore);
        // const { pricing, hasChanges } = useState("pricing", ["pricing", "hasChanges"]); //todo in near future
        return { layouts };
    },
    computed: {
        ...mapState("pricing", ["pricing", "hasChanges"]),
    },
    methods: {
        ...mapActions("pricing/projects", ["saveSnapshot"]),
    },
};
</script>
